import type { PropsWithChildren } from 'react';

import * as css from './styles.css';

interface PanelProps extends PropsWithChildren {}

export function Panel({ children }: PanelProps) {
	return <div className={css.panel}>{children}</div>;
}
